import React, { Component } from "react";
import { Row, Col, notification } from "antd";
import { connect } from "react-redux";
import {
  ModalItem,
  Form,
  FormItem,
  InputItem,
  ButtonItem,
} from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import AgregarCliente from "../../Ventas/AgregarVenta/AgregarCliente/AgregarCliente";
import axios from "axios";

class ModalContacto extends Component {
  formRef = React.createRef();

  state = {
    modalAgregarClienteVisible: false,
    loading: false,
    fetchingData: false,
  };

  componentDidMount() {
    if (this.props.visible && this.props.idContacto) {
      this.cargarDatos(this.props.idContacto);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      if (this.props.idContacto) {
        this.cargarDatos(this.props.idContacto);
      } else {
        if (this.formRef.current) {
          this.formRef.current.resetFields();
          if (this.props.datosIniciales) {
            this.formRef.current.setFieldsValue(this.props.datosIniciales);
          }
        }
      }
    }
  }

  cargarDatos = (id) => {
    this.setState({ fetchingData: true });

    axios
      .post(
        "contactos/datosContacto",
        { id, empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.success === 2) {
          const contacto = res.data.data;
          if (this.formRef.current) {
            console.log(res.data);
            this.formRef.current.setFieldsValue({
              ...contacto,
              clienteId: contacto.clienteId?._id || contacto.clienteId,
            });
          }
        } else {
          notification.error({ message: res.data.message });
          this.cerrarModal();
        }
      })
      .catch((error) => {
        console.error(error);
        notification.error({ message: "Error al cargar datos del contacto." });
      })
      .finally(() => {
        this.setState({ fetchingData: false });
      });
  };

  onFinish = (values) => {
    this.setState({ loading: true });

    const payload = {
      ...values,
      _id: this.props.idContacto,
      empresaId: this.props.empresaId,
    };

    axios
      .post("contactos/guardarContacto", payload, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.success === 2) {
          notification.success({ message: res.data.message });
          if (this.props.onSuccess) {
            this.props.onSuccess(res.data.data?._id ?? null, res.data.data);
          }

          this.cerrarModal();
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch((error) => {
        console.error(error);
        notification.error({ message: "Error al guardar el contacto." });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  cerrarModal = () => {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.props.onCancel();
  };

  abrirAgregarCliente = () => {
    this.setState({ modalAgregarClienteVisible: true });
  };

  cerrarAgregarCliente = (idNuevoCliente) => {
    this.setState({ modalAgregarClienteVisible: false });

    if (idNuevoCliente && this.formRef.current) {
      this.formRef.current.setFieldsValue({ clienteId: idNuevoCliente });
    }
  };

  render() {
    const { visible, empresaId, headersToken, idContacto, verDetalle } =
      this.props;
    const { fetchingData, loading } = this.state;

    let tituloModal = "Nuevo Contacto";
    if (idContacto) {
      tituloModal = verDetalle ? "Detalles del Contacto" : "Editar Contacto";
    }

    return (
      <>
        <AgregarCliente
          visible={this.state.modalAgregarClienteVisible}
          cerrarModal={this.cerrarAgregarCliente}
          zIndex={this.props.zIndex}
        />

        <ModalItem
          title={tituloModal}
          visible={visible}
          onCancel={this.cerrarModal}
          spinning={fetchingData}
          width={800}
          zIndex={this.props.zIndex}
        >
          <Form
            ref={this.formRef}
            name="form_modal_contacto"
            layout="vertical"
            onFinish={this.onFinish}
            bottom={
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <ButtonItem
                  rojo
                  onClick={this.cerrarModal}
                  style={{ marginRight: 8 }}
                  disabled={loading}
                >
                  {verDetalle ? "Cerrar" : "Cancelar"}
                </ButtonItem>

                {!verDetalle && (
                  <ButtonItem azul htmlType="submit" loading={loading}>
                    {idContacto ? "Guardar Cambios" : "Crear Contacto"}
                  </ButtonItem>
                )}
              </div>
            }
          >
            <Row gutter={16}>
              <Col span={12}>
                <FormItem
                  name="nombre"
                  label="Nombre"
                  required={!verDetalle}
                  margin
                  wrapperLabel={12}
                  labelCol={12}
                >
                  <InputItem
                    placeholder="Nombre del contacto"
                    disabled={verDetalle}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  name="apellidoPaterno"
                  label="Apellido Paterno"
                  required={!verDetalle}
                  margin
                  wrapperLabel={12}
                  labelCol={12}
                >
                  <InputItem
                    placeholder="Apellido Paterno"
                    disabled={verDetalle}
                  />
                </FormItem>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <FormItem
                  name="apellidoMaterno"
                  label="Apellido Materno"
                  margin
                  wrapperLabel={12}
                  labelCol={12}
                >
                  <InputItem
                    placeholder="Apellido Materno"
                    disabled={verDetalle}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={22}>
                    <FormItem name="clienteId" label="Cliente/Empresa" margin>
                      <SelectClientesItem
                        empresaId={empresaId}
                        headersToken={headersToken}
                        sinBorde
                        width="100%"
                        placeholder="Buscar cliente/empresa..."
                        disabled={verDetalle}
                      />
                    </FormItem>
                  </Col>
                  <Col
                    span={2}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <ButtonItem
                      type="primary"
                      icon="+"
                      style={{
                        marginTop: "auto",
                      }}
                      onClick={this.abrirAgregarCliente}
                      tooltip="Agregar nuevo cliente/empresa"
                      disabled={verDetalle}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <FormItem
                  name="numero"
                  label="Teléfono"
                  margin
                  wrapperLabel={12}
                  labelCol={12}
                >
                  <InputItem
                    placeholder="Ej: 444-123-4567"
                    disabled={verDetalle}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  name="correo"
                  label="Correo Electrónico"
                  email
                  margin
                  wrapperLabel={12}
                  labelCol={12}
                >
                  <InputItem
                    placeholder="ejemplo@empresa.com"
                    disabled={verDetalle}
                  />
                </FormItem>
              </Col>
            </Row>

            <FormItem name="origen" label="Origen del Contacto" margin>
              <InputItem
                placeholder="Ej: Facebook, Expo, Recomendación..."
                disabled={verDetalle}
              />
            </FormItem>
          </Form>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ModalContacto);
